import { Tabs } from "antd";
import AppLayout from "../../components/Layout";

// Import your Knowlarity component
import Campaign from "../Campaign"; // Update the path if needed
import { SolveesyDiallerTable } from "../SolveesyDialler";
import SolveesyDialler from "../SolveesyDialler/dialler";



export const Dialler = () => {
  const items = [
    {
      key: "1",
      label: "Knowlarity",
      children: <Campaign />,
    },
    {
      key: "2",
      label: "Solveesy Dialler",
      children: <SolveesyDialler />,
    },
  ];

  return (
    <AppLayout moduleName="Dialler">
      <Tabs items={items} />
    </AppLayout>
  );
};